import useGetCustomerById from '@api/queries/getCustomerById/useGetCustomerById';
import MessageInputFooter from './components/MessageInputFooter';
import MessageThread from './components/MessageThread';
import { mockedMessageSession } from './components/MessageThread/api/queries/mocks/mockedGetCustomerMessages';
import MessageViewHeader from './components/MessageViewHeader';
import styles from './MessageView.module.css';

interface MessageViewProps {
  tenantId: string;
  customerId?: string;
  phoneNumber: string;
}

/**
 * Responsible for fetching the customer rendering the message header, footer input and thread components.
 * It uses the same customer query as the CustomerDetails component.
 */
const MessageView = ({
  tenantId,
  customerId,
  phoneNumber,
}: MessageViewProps) => {
  const { customer } = useGetCustomerById(tenantId, customerId);
  const customerName = customer?.name;

  return (
    <div className={styles.messageViewContainer}>
      <MessageViewHeader
        phoneNumber={phoneNumber}
        customerName={customerName}
      />
      <MessageThread
        sessions={mockedMessageSession}
        sessionId='123'
        onFetchMoreMessages={() => {}}
      />
      <MessageInputFooter onSendMessage={() => {}} />
    </div>
  );
};

export default MessageView;
